import { Action, Dispatch, bindActionCreators } from 'redux';
import { Visits, StateProps, DispatchProps } from '../components/visit/Visits';
import { createBreak, deleteBreak, editBreak } from '../redux/providers/actions';
import { onPageDidMount, onPageWillUnmount } from '../redux/core';
import { setVisitCode, setVisitFilterText } from '../redux/ui/actions';
import { toast } from '../redux/message/actions';

import { RootState } from '../redux/types';
import { connect } from 'react-redux';

import { VisitsAction } from '../redux/visits/actions';

export function mapStateToProps(state: RootState): StateProps {
  return {
    markets: state.markets.markets,
    marketCodes: state.ui.markets,
    serviceTypes: state.ui.services,
    date: state.ui.date,
    visits: state.visits.visits,
    visitCodeToVisitIndex: state.visits.visitCodeToVisitIndex,
    visitFilterText: state.ui.visitFilterText,
    visitCode: state.ui.visitCode,
    marketToBreaks: state.providers.marketToBreaks,
    marketToProviderSchedules: state.providers.marketToProviderSchedules,
    allProviders: state.providers.allProviders,
  };
}

export function mapDispatchToProps(dispatch: Dispatch<Action>): DispatchProps {
  return {
    actions: bindActionCreators(
      {
        setVisitCode,
        onPageDidMount,
        onPageWillUnmount,
        setVisitFilterText,
        createBreak,
        editBreak,
        deleteBreak,
        toast,
        refreshVisits: () => dispatch({ type: VisitsAction.REFRESH_VISITS }),
      },
      dispatch
    ),
  };
}

export const VisitsContainer = connect(mapStateToProps, mapDispatchToProps)(Visits);
